(() => {
  const init = (root) => {
    if (root.dataset.liftInitialized === 'true') return;
    root.dataset.liftInitialized = 'true';

    const form = root.querySelector('form[action*="/cart/add"]');
    const variantSelect = form?.querySelector('select[name="id"], input[name="id"]');
    const variantData = root.querySelector('[data-lift-variants]');
    const bookingState = root.querySelector('[data-lift-booking-state]');
    if (!form || !variantSelect || !variantData) return;

    let variants;
    try { variants = JSON.parse(variantData.textContent); } catch { return; }
    const currency = root.dataset.currency || 'USD';
    const formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency });
    const money = (cents) => formatter.format(cents / 100);
    let selectedDays = 0;
    let currentVariant;

    // BookX uses the product quantity when it calculates a multi-day booking.
    // Keep Empire's quantity input in the form and fix it at one lift per request.
    const quantity = form.querySelector('[data-quantity-input]');
    if (quantity) {
      quantity.value = '1';
      quantity.min = '1';
      quantity.max = '1';
      quantity.tabIndex = -1;
      quantity.closest('.quantity-selector')?.setAttribute('aria-hidden', 'true');
      form.querySelectorAll('[data-quantity-step]').forEach((button) => {
        button.disabled = true;
        button.tabIndex = -1;
      });
    }

    const decorateOptions = () => {
      form.querySelectorAll('.options-selection__option-value-label').forEach((label) => {
        const option = label.querySelector('[data-variant-option-value]');
        const variant = variants.find((item) => item.title === option?.value || item.option1 === option?.value);
        if (!variant) return;
        if (!label.querySelector('.excel-lift__option-image')) {
          const image = document.createElement('img');
          image.className = 'excel-lift__option-image';
          image.src = variant.featured_image?.src || root.dataset.liftThumbnail;
          image.alt = '';
          image.width = 96;
          image.height = 72;
          image.loading = 'lazy';
          label.insertBefore(image, label.querySelector('.options-selection__option-value-name'));
        }
        if (!label.querySelector('.excel-lift__option-rate')) {
          const rate = document.createElement('span');
          rate.className = 'excel-lift__option-rate';
          rate.textContent = `${money(variant.price)} / day`;
          label.append(rate);
        }
      });
    };

    const setText = (selector, value) => {
      root.querySelectorAll(selector).forEach((node) => {
        if (node.textContent !== value) node.textContent = value;
      });
    };

    const updateRate = () => {
      if (!currentVariant) return;
      setText('[data-lift-price]', money(currentVariant.price));
    };

    const syncVariant = () => {
      currentVariant = variants.find((item) => String(item.id) === String(variantSelect.value));
      updateRate();
    };

    const syncBookXButton = () => {
      if (!bookingState) return;
      const button = form.querySelector('.bookeasy-btn');
      if (button) {
        if (currentVariant) {
          button.dataset.variantId = String(currentVariant.id);
          button.dataset.variantName = currentVariant.title;
          button.dataset.price = String(currentVariant.price / 100);
        }
        bookingState.hidden = true;
        bookingState.textContent = '';
      }
    };

    const syncBookXEstimate = () => {
      const calendar = document.querySelector('bookeasy-calendar-v2');
      if (calendar) {
        const countText = calendar.querySelector('.bookeasy-multi-day-selected-dates-title-count')?.textContent || '';
        const count = Number(countText.match(/\d+/)?.[0] || 0);
        selectedDays = count;
      }

      const footer = document.querySelector('bookeasy-footer-v2 .bookeasy-footer-container');
      if (!footer || !currentVariant) return;
      let estimate = footer.querySelector('.excel-lift__bookx-estimate');
      if (!estimate) {
        estimate = document.createElement('p');
        estimate.className = 'excel-lift__bookx-estimate';
        estimate.setAttribute('aria-live', 'polite');
        footer.insertBefore(estimate, footer.querySelector('.bookeasy-footer-buttons'));
      }
      const daily = money(currentVariant.price);
      const label = selectedDays
        ? `Estimate: ${money(currentVariant.price * selectedDays)} for ${selectedDays} ${selectedDays === 1 ? 'day' : 'days'} at ${daily}/day`
        : `${daily}/day · select rental dates`;
      if (estimate.textContent !== label) estimate.textContent = label;
    };

    let bookXFrameQueued = false;
    const queueBookXEstimate = () => {
      if (bookXFrameQueued) return;
      bookXFrameQueued = true;
      requestAnimationFrame(() => {
        bookXFrameQueued = false;
        syncBookXEstimate();
      });
    };
    const modalObserver = new MutationObserver(queueBookXEstimate);
    form.addEventListener('click', (event) => {
      if (!event.target.closest('.bookeasy-btn')) return;
      selectedDays = 0;
      queueBookXEstimate();
    }, true);
    // BookX may stop click propagation while opening its modal. Watch for the
    // calendar independently so its selected dates always reach the estimate.
    modalObserver.observe(document.body, { childList: true, subtree: true, characterData: true });

    const syncSelection = () => {
      syncVariant();
      if (!currentVariant) return;
      const variantId = String(currentVariant.id);
      const url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== variantId) {
        url.searchParams.set('variant', variantId);
        window.history.replaceState(window.history.state, '', url);
      }
      // BookX observes DOM changes and rebinds its button when the URL's
      // variant changes. Trigger that observer even if Empire set the URL first.
      if (root.dataset.liftVariant !== variantId) root.dataset.liftVariant = variantId;
      syncBookXButton();
    };

    form.addEventListener('change', (event) => {
      if (!event.target.matches('[data-variant-option-value], [data-variants]')) return;
      requestAnimationFrame(syncSelection);
    });
    variantSelect.addEventListener('change', syncSelection);
    const buttonObserver = new MutationObserver(() => {
      decorateOptions();
      syncBookXButton();
    });
    buttonObserver.observe(form, { childList: true, subtree: true });
    window.setTimeout(() => {
      if (!form.querySelector('.bookeasy-btn') && bookingState) {
        bookingState.innerHTML = 'BookX is not available right now. <a href="tel:+15866933435">Call our Warren team</a> for help with your rental request.';
        bookingState.hidden = false;
      }
    }, 10000);

    decorateOptions();
    syncVariant();
    syncBookXButton();
  };

  const boot = () => document.querySelectorAll('[data-excel-lift]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
